import {
  Typography,
  Box,
  Divider,
  Dialog,
  IconButton,
  makeStyles,
  CloseOutlined as CloseOutlinedIcon,
} from '@quillbot/design-system';
import NewQuillBtn from '@Common/quillElements/button/NewQuillBtn';
import QuillLocalStorage from 'core/utils/localStorageClient';
import { QUILLPRODUCTS } from '@Common/models';
import Track from '@Common/handlers/track';
import { RootState } from '../models/redux/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Img from './img';

const useStyles = makeStyles(() => ({
  paper: {
    boxShadow: '0 4px 4px 0 rgb(0 0 0 / 25%)',
    borderRadius: '10px',
  },
}));

export interface ModalProps {
  variant: string;
}

function ProductUpSellModal(props: ModalProps) {
  const { variant } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const crossProductUpsell = useSelector((rootState: RootState) => rootState?.common.crossProductUpsell);

  useEffect(() => {
    if (
      crossProductUpsell === QUILLPRODUCTS.PLAGIARISM_CHECKER &&
      QuillLocalStorage.getInstance().get('plagCheckUpsell', 'false') === 'false'
    ) {
      Track.interactedCrossProductUpsellModal(QUILLPRODUCTS.PLAGIARISM_CHECKER, 'shown');
      setOpen(true);
    }
  }, [crossProductUpsell]);

  const handleClose = () => {
    QuillLocalStorage.getInstance().set('plagCheckUpsell', 'true');
    setOpen(false);
  };

  const closeModal = () => {
    Track.interactedCrossProductUpsellModal(QUILLPRODUCTS.PLAGIARISM_CHECKER, 'closed');
    handleClose();
  };

  function btnClickHandler() {
    Track.interactedCrossProductUpsellModal(QUILLPRODUCTS.PLAGIARISM_CHECKER, 'accepted');
    handleClose();
    window.open('/plagiarism-checker?referrer=plagCheckUpSellModal');
  }

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      fullWidth
      maxWidth="xs"
      classes={classes}
      aria-labelledby="Product upsell"
      aria-describedby="Dialog box upselling Plagiarism checker">
      <Box display="flex" justifyContent="flex-end">
        <IconButton
          style={{ padding: '8px' }}
          onClick={() => {
            closeModal();
          }}
          size="large">
          <CloseOutlinedIcon />
        </IconButton>
      </Box>
      <Box px="28px">
        <Box display="flex" alignItems="center">
          <Box component="span">
            <Box
              height={68}
              width={68}
              display="flex"
              justifyContent="center"
              alignItems="center"
              bgcolor="#F27C0E"
              borderRadius={100}>
              <Img
                style={{ width: 40, height: 40 }}
                src="/images/theme/commonImages/plag-checker-new.svg"
                alt="plagiarism checker icon"
              />
            </Box>
          </Box>
          <Box pr="15px" />
          <Typography fontSize="20px" color="" lineHeight="30px">
            Save yourself from accidental plagiarism—check out our&nbsp;
            <Typography component="span" fontSize="inherit" color="#F27C0E" fontWeight={600}>
              Plagiarism Checker!
            </Typography>
          </Typography>
        </Box>
        <Box pt="24px" />
        <Divider />
        <Box pt="24px" />
        <Box textAlign="center">
          <NewQuillBtn
            style={{
              fontWeight: 700,
              padding: '8px 14px',
              borderRadius: '20px',
              lineHeight: '19px',
            }}
            disabled={false}
            className="articleBtn"
            color="primary"
            variant="contained"
            onClick={btnClickHandler}
            buttonText="Try Plagiarism Checker"
          />
        </Box>

        <Box pt="24px" />
      </Box>
    </Dialog>
  );
}

export default ProductUpSellModal;
